// extracted by mini-css-extract-plugin
export var noSpinners = "_o8-6";
export var percentageInput = "_o8-7";
export var variantColor1 = "_o8-0";
export var variantColor2 = "_o8-1";
export var variantColor3 = "_o8-2";
export var variantColor4 = "_o8-3";
export var variantColor5 = "_o8-4";
export var variantColor6 = "_o8-5";